import axios from "axios";
import { getToken } from "../../Utilities/LocalStorage";

const headers = {
  "Content-Type": "application/json",
};

const PromoCodeService = axios.create({
  baseURL: process.env.REACT_APP_API_END_POINT + "/v1/promo",
  headers: headers,
});

PromoCodeService.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

PromoCodeService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

export default PromoCodeService;
